/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it
import "./src/styles/custom.scss"
// import "./src/styles/global.css"
import "bootstrap/dist/js/bootstrap"
require('typeface-cormorant-garamond');